import React from 'react';

export default function PaymentFailure() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2>El pago no pudo completarse</h2>
      <p>Ocurrió un error al procesar tu pago. Por favor, intenta nuevamente o utiliza otro método de pago.</p>
      <a href="/onboarding">Volver al inicio</a>
    </div>
  );
} 